<template>
  <div class="animate-route">
    <details-info :title="newsInfo.name" :htmlStr="newsInfo.content"> </details-info>
  </div>
</template>
<script>
import DetailsInfo from '@/components/DetailsInfo'
import { getNewsById } from '@/api'
export default {
  components: {
    DetailsInfo,
  },
  data() {
    return {
      newsInfo: {},
    }
  },
  created() {
    const id = this.$route.query.id
    getNewsById({ id: id }).then((res) => {
      this.newsInfo = res.result
    })
  },
}
</script>
<style lang="stylus">
@import './index'
route()
</style>
